if (!customElements.get('video-sound-control')) {
    class VideoSoundControl extends HTMLElement {
      constructor() {
        super();
        this.isMuted = true;
        this.boundToggleSound = this.toggleSound.bind(this);
      }
  
      connectedCallback() {
        this.button = this.querySelector('[data-video-sound-button]');
        if (this.button) {
          this.button.addEventListener('click', this.boundToggleSound);
          this.findVideo();
        }
      }
  
      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.boundToggleSound);
        }
      }
  
      findVideo() {
        const checkVideo = setInterval(() => {
          // Primero busca dentro del deferred-media template
          const deferredMedia = this.closest('.password-background').querySelector('deferred-media template');
          if (deferredMedia) {
            // Si aún está en template, busca en el DOM real
            const videoComponent = this.closest('.password-background').querySelector('video-component');
            if (videoComponent) {
              const video = videoComponent.querySelector('video');
              if (video) {
                this.video = video;
                this.button.setAttribute('data-muted', 'true');
                video.muted = true; // Aseguramos que inicie muteado
                clearInterval(checkVideo);
              }
            }
          }
        }, 100);

        // Añadimos un timeout de seguridad
        setTimeout(() => {
          clearInterval(checkVideo);
        }, 10000); // 10 segundos máximo
      }
  
      toggleSound() {
        if (!this.video) {
          console.log('Video not found');
          return;
        }
        
        this.isMuted = !this.isMuted;
        this.video.muted = this.isMuted;
        this.button.setAttribute('data-muted', this.isMuted);
        
        // Debug
        console.log('Toggle sound:', this.isMuted ? 'OFF' : 'ON');
      }
    }
  
    customElements.define('video-sound-control', VideoSoundControl);
}